var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "Thêm khoản thu",
        visible: _vm.dialogVisibleAdd,
        width: "1150px",
        "before-close": _vm.closeDialog,
        "close-on-click-modal": false,
        top: "4vh",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisibleAdd = $event
        },
        open: _vm.handleOpen,
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "dataInput",
          attrs: {
            "label-width": "160px",
            model: _vm.dataInput,
            "label-position": "left",
            rules: _vm.rules,
          },
        },
        [
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { attrs: { span: 16 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "Chọn khoản", prop: "idPackage" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { placeholder: "Chọn khoản", filterable: "" },
                          on: {
                            change: function ($event) {
                              return _vm.selectPackageMethod()
                            },
                          },
                          model: {
                            value: _vm.idPackage,
                            callback: function ($$v) {
                              _vm.idPackage = $$v
                            },
                            expression: "idPackage",
                          },
                        },
                        _vm._l(_vm.responseList, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.name, value: item.id },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "Loại", prop: "category" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { disabled: "", placeholder: "Loại" },
                          on: {
                            change: function ($event) {
                              return _vm.resetAttendanceMethod()
                            },
                          },
                          model: {
                            value: _vm.dataInput.category,
                            callback: function ($$v) {
                              _vm.$set(_vm.dataInput, "category", $$v)
                            },
                            expression: "dataInput.category",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "Thu", value: "in" },
                          }),
                          _c("el-option", {
                            attrs: { label: "Chi", value: "out" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "Mô tả", prop: "description" } },
            [
              _c("el-input", {
                attrs: {
                  disabled: "",
                  rows: 2,
                  type: "textarea",
                  autosize: "",
                  placeholder: "Nhập mô tả",
                },
                model: {
                  value: _vm.dataInput.description,
                  callback: function ($$v) {
                    _vm.$set(_vm.dataInput, "description", $$v)
                  },
                  expression: "dataInput.description",
                },
              }),
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "Số lượng", prop: "number" } },
                    [
                      _c("el-input-number", {
                        attrs: { disabled: "", precision: 0, min: 1 },
                        model: {
                          value: _vm.dataInput.number,
                          callback: function ($$v) {
                            _vm.$set(_vm.dataInput, "number", $$v)
                          },
                          expression: "dataInput.number",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "Đơn giá", prop: "price" } },
                    [
                      _c("el-currency-input", {
                        attrs: { disabled: "" },
                        model: {
                          value: _vm.dataInput.price,
                          callback: function ($$v) {
                            _vm.$set(_vm.dataInput, "price", $$v)
                          },
                          expression: "dataInput.price",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "Giảm giá", prop: "discount" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          attrs: { disabled: "" },
                          model: {
                            value: _vm.dataInput.discount,
                            callback: function ($$v) {
                              _vm.$set(_vm.dataInput, "discount", $$v)
                            },
                            expression: "dataInput.discount",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: true } }, [
                            _vm._v("Có"),
                          ]),
                          _c("el-radio", { attrs: { label: false } }, [
                            _vm._v("Không"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.dataInput.discount
                ? _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "Loại giảm giá",
                            prop: "discountType",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { placeholder: "Loại", disabled: "" },
                              model: {
                                value: _vm.dataInput.discountType,
                                callback: function ($$v) {
                                  _vm.$set(_vm.dataInput, "discountType", $$v)
                                },
                                expression: "dataInput.discountType",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: { label: "Phần trăm", value: "percent" },
                              }),
                              _c("el-option", {
                                attrs: { label: "Tiền", value: "money" },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.dataInput.discount
                ? _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label:
                              _vm.dataInput.discountType === "percent"
                                ? "Phần trăm giảm"
                                : "Tiền giảm",
                            prop: "discountNumber",
                          },
                        },
                        [
                          _vm.dataInput.discountType === "percent"
                            ? _c("el-input-number", {
                                attrs: {
                                  disabled: "",
                                  precision: 0,
                                  min: 0,
                                  max: 100,
                                },
                                model: {
                                  value: _vm.dataInput.discountNumber,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.dataInput,
                                      "discountNumber",
                                      $$v
                                    )
                                  },
                                  expression: "dataInput.discountNumber",
                                },
                              })
                            : _vm.dataInput.discountType === "money"
                            ? _c("el-currency-input", {
                                attrs: { disabled: "" },
                                model: {
                                  value: _vm.dataInput.discountNumber,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.dataInput,
                                      "discountNumber",
                                      $$v
                                    )
                                  },
                                  expression: "dataInput.discountNumber",
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _vm.dataInput.discount
                ? _c(
                    "el-col",
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "Đơn giá khi giảm",
                            prop: "discountPrice",
                          },
                        },
                        [
                          _c("currency-input", {
                            staticStyle: {
                              padding: "10px",
                              width: "98%",
                              "text-align": "right",
                              background: "#e7e9ec",
                              border: "1px solid #dcdfe6",
                              "font-weight": "bold",
                            },
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.dataInput.discountPrice,
                              callback: function ($$v) {
                                _vm.$set(_vm.dataInput, "discountPrice", $$v)
                              },
                              expression: "dataInput.discountPrice",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                [
                  _c("el-form-item", { attrs: { label: "Số tiền bằng chữ" } }, [
                    _c(
                      "span",
                      {
                        staticStyle: {
                          "font-weight": "bold",
                          "font-style": "italic",
                        },
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.numberToWordsVN(_vm.dataInput.discountPrice)
                          )
                        ),
                      ]
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "Trạng thái sử dụng",
                        prop: "usingStatus",
                      },
                    },
                    [
                      _c(
                        "el-radio-group",
                        {
                          attrs: { disabled: "" },
                          model: {
                            value: _vm.dataInput.usingStatus,
                            callback: function ($$v) {
                              _vm.$set(_vm.dataInput, "usingStatus", $$v)
                            },
                            expression: "dataInput.usingStatus",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: true } }, [
                            _vm._v("Đang sử dụng"),
                          ]),
                          _c(
                            "el-radio",
                            {
                              attrs: {
                                label: false,
                                disabled: _vm.exitClassOrGroup,
                              },
                            },
                            [_vm._v("Ngừng sử dụng")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: "Áp dụng điểm danh", prop: "attendance" },
                    },
                    [
                      _c(
                        "el-radio-group",
                        {
                          attrs: { disabled: "" },
                          model: {
                            value: _vm.dataInput.attendance,
                            callback: function ($$v) {
                              _vm.$set(_vm.dataInput, "attendance", $$v)
                            },
                            expression: "dataInput.attendance",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: true } }, [
                            _vm._v("Có"),
                          ]),
                          _c("el-radio", { attrs: { label: false } }, [
                            _vm._v("Không"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.dataInput.attendance
                ? _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: "Kiểu trả", prop: "attendancePaid" },
                        },
                        [
                          _c(
                            "el-radio-group",
                            {
                              attrs: { disabled: "" },
                              on: {
                                change: function ($event) {
                                  return _vm.resetAttendanceMethod()
                                },
                              },
                              model: {
                                value: _vm.dataInput.attendancePaid,
                                callback: function ($$v) {
                                  _vm.$set(_vm.dataInput, "attendancePaid", $$v)
                                },
                                expression: "dataInput.attendancePaid",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: "before" } }, [
                                _vm._v("Trả trước"),
                              ]),
                              _c("el-radio", { attrs: { label: "after" } }, [
                                _vm._v("Trả sau"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm.dataInput.attendance
            ? _c("el-row", { attrs: { gutter: 20 } }, [
                _vm.dataInput.attendancePaid === "before"
                  ? _c(
                      "span",
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 8 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "Loại điểm danh",
                                  prop: "attendanceType",
                                },
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: {
                                      disabled: "",
                                      placeholder: "Chọn loại điểm danh",
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.changeAttendanceTypeMethod()
                                      },
                                    },
                                    model: {
                                      value: _vm.dataInput.attendanceType,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.dataInput,
                                          "attendanceType",
                                          $$v
                                        )
                                      },
                                      expression: "dataInput.attendanceType",
                                    },
                                  },
                                  _vm._l(
                                    this.$funcData.funcAttendanceTypeNewList(),
                                    function (item) {
                                      return _c("el-option", {
                                        key: item.key,
                                        attrs: {
                                          value: item.key,
                                          label: item.value,
                                        },
                                      })
                                    }
                                  ),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm.dataInput.attendanceType !== "pickupLate"
                          ? _c(
                              "el-col",
                              { attrs: { span: 8 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "Chi tiết",
                                      prop: "attendanceDetail",
                                    },
                                  },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticStyle: { width: "250px" },
                                        attrs: {
                                          disabled: "",
                                          placeholder: "Chọn chi tiết",
                                        },
                                        model: {
                                          value: _vm.dataInput.attendanceDetail,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.dataInput,
                                              "attendanceDetail",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "dataInput.attendanceDetail",
                                        },
                                      },
                                      _vm._l(
                                        _vm.attendanceDetailNewList,
                                        function (item) {
                                          return _c("el-option", {
                                            key: item.key,
                                            attrs: {
                                              value: item.key,
                                              label: item.value,
                                            },
                                          })
                                        }
                                      ),
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    )
                  : _vm.dataInput.attendancePaid === "after"
                  ? _c(
                      "span",
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 8 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "Loại điểm danh",
                                  prop: "attendanceType",
                                },
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: {
                                      disabled: "",
                                      placeholder: "Chọn loại điểm danh",
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.changeAttendanceTypeMethod()
                                      },
                                    },
                                    model: {
                                      value: _vm.dataInput.attendanceType,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.dataInput,
                                          "attendanceType",
                                          $$v
                                        )
                                      },
                                      expression: "dataInput.attendanceType",
                                    },
                                  },
                                  _vm._l(
                                    _vm.attendanceTypeList,
                                    function (item) {
                                      return _c("el-option", {
                                        key: item.key,
                                        attrs: {
                                          value: item.key,
                                          label: item.value,
                                        },
                                      })
                                    }
                                  ),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm.dataInput.attendanceType !== "pickupLate"
                          ? _c(
                              "el-col",
                              { attrs: { span: 8 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "Chi tiết",
                                      prop: "attendanceDetail",
                                    },
                                  },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticStyle: { width: "250px" },
                                        attrs: {
                                          disabled: "",
                                          placeholder: "Chọn chi tiết",
                                        },
                                        model: {
                                          value: _vm.dataInput.attendanceDetail,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.dataInput,
                                              "attendanceDetail",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "dataInput.attendanceDetail",
                                        },
                                      },
                                      _vm._l(
                                        _vm.attendanceDetailList,
                                        function (item) {
                                          return _c("el-option", {
                                            key: item.key,
                                            attrs: {
                                              value: item.key,
                                              label: item.value,
                                            },
                                          })
                                        }
                                      ),
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    )
                  : _vm._e(),
              ])
            : _vm._e(),
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              attrs: { type: "danger", size: "medium" },
              on: {
                click: function ($event) {
                  return _vm.closeDialog()
                },
              },
            },
            [
              _c("i", { staticClass: "el-icon-circle-close" }),
              _c("span", [_vm._v(_vm._s(_vm.$t("button.close")))]),
            ]
          ),
          _c(
            "el-button",
            {
              attrs: {
                type: "success",
                size: "medium",
                loading: _vm.loadingButton,
                mini: "",
              },
              on: {
                click: function ($event) {
                  return _vm.submitForm()
                },
              },
            },
            [
              _c("i", { staticClass: "el-icon-circle-check" }),
              _c("span", [_vm._v("Thêm")]),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }